import React, { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { messageService } from "../../Services/message.service";
import CardWrap from "../Common/CardWrap";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import { globalServices } from "../../Services/global.service";
import { AuthContext } from "../../Contexts/AuthContext";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { roles } from "../../Config/Roles";
import AsyncSelect from "react-select/async";
import Tooltip from "../Common/Tooltip";

export default function AddMessage() {
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const history = useHistory();
  const [tenants, setTenants] = React.useState();
  const { roleId, userId } = useContext(AuthContext);
  const { locTenant } = useContext(GlobalContext);
  const { master, admin, support } = roles;

  const initialState = {
    tenantId: null,
    title: "",
    text: "",
  };

  const [message, setMessage] = useState(initialState);
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setMessage({ ...message, [name]: value });
  };

  const goBack = () => {
    history.push("/messages");
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  useEffect(() => {
    if (![master, admin, support].includes(Number(roleId)))
      history.push("/error-page/401");
    else {
      globalServices
        .getTenants()
        .then((data) => {
          setTenants(data.data);
        })
        .catch(() => history.push("/Error"));
    }
  }, []);

  const onSubmit = (data) => {
    messageService
      .create({
        tenantId: Number(message.tenantId),
        title: data.title,
        text: data.text,
      })
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("Message-AddMessage-SuccessModal-Title"),
              text: translator("Message-AddMessage-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setModal({
              show: true,
              title: translator("Message-AddMessage-UnsuccessModal-Title"),
              text: translator("Message-AddMessage-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("Message-AddMessage-UnsuccessModal-Title"),
          text: translator("Message-AddMessage-UnsuccessModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));
        result.unshift({
          id: 0,
          label: translator("SelectTenant-Choose"),
          oib: "",
        });
        return result;
      })
      .catch((err) => err);
  };

  const handleCancel = () => {
    history.push("/messages");
  };

  return (
    <CardWrap
      subtitle={translator("Message-AddMessage-Subtitle")}
      backUrl={"/messages"}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Message-AddMessage-Legend-BasicInformation")}
            </legend>
            <div className="form-group">
              <label>{translator("Message-AddMessage-Tenant")}</label>{" "}
              <Tooltip text={translator("Message-Tenant-Msg")} />
              <AsyncSelect
                name="tenantId"
                onChange={(event) => {
                  setTenantObj({
                    id: event.id,
                    label: event.label,
                    value: event.value,
                  });
                  setMessage({ ...message, tenantId: event.id });
                }}
                defaultOptions={true}
                loadOptions={promiseOptions}
                placeholder={translator("Select-Tenant")}
                value={tenantObj}
              />
            </div>
            <div className="form-group">
              <label>{translator("Message-AddMessage-InputTitle")}</label>{" "}
              <Tooltip text={translator("Message-InputTitle-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: true,
                  maxLength: 200,
                })}
                name="title"
                defaultValue={message.title}
              />
              {errors.title && errors.title.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.title && errors.title.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength200")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Message-AddMessage-InputText")}</label>{" "}
              <Tooltip text={translator("Message-InputText-Msg")} />
              <textarea
                id="textArea"
                rows="4"
                className="form-control"
                name="text"
                defaultValue={message.text}
                ref={register({
                  required: true,
                  maxLength: 4000,
                })}
              />
              {errors.text && errors.text.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.text && errors.text.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength4000")}
                </p>
              )}
            </div>
          </fieldset>
        </div>
        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
}
